import { createFileRoute, redirect } from '@tanstack/react-router';

// Only the learning path tab exists for now.
export const Route = createFileRoute('/redacoes/')({
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/redacoes/trilha-de-aprendizagem', search, replace: true });
  },
});
